import classNames from 'classnames';
import React from 'react';

import { IBlogCardProps } from '../../BlogCard';
import './Related.scss';

const ROOT_CLASSNAME = 'BlogCard';

const Related: React.FunctionComponent<IBlogCardProps> = ({
  className,
  children,
}) => {
  return (
    <article className={classNames(`${ROOT_CLASSNAME}--related`, className)}>
      {children}
    </article>
  );
};

export default Related;
